import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

const ACTION_PREFIX = "[Campaign]";

export const CAMPAIGN_ACTION_TYPE = {
	joinByCode: `${ACTION_PREFIX} Join By Code`,
	joinByCodeSuccess: `${ACTION_PREFIX} Join By Code Success`,
	joinByCodeFail: `${ACTION_PREFIX} Join By Code Fail`,

	optIn: `${ACTION_PREFIX} Opt In`,
	optInSuccess: `${ACTION_PREFIX} Opt In Success`,
	optInFail: `${ACTION_PREFIX} Opt In Fail`,
};

@Injectable({
	providedIn: "root",
})
export class CampaignAction {
	joinByCode(campaignCode: string): ActionWithPayload {
		return {
			type: CAMPAIGN_ACTION_TYPE.joinByCode,
			payload: campaignCode,
		};
	}

	joinByCodeSuccess(): Action {
		return {
			type: CAMPAIGN_ACTION_TYPE.joinByCodeSuccess,
		};
	}

	joinByCodeFail(error: AppError): ActionWithPayload {
		return {
			type: CAMPAIGN_ACTION_TYPE.joinByCodeFail,
			payload: error,
		};
	}

	optIn(campaignCode: string): ActionWithPayload {
		return {
			type: CAMPAIGN_ACTION_TYPE.optIn,
			payload: campaignCode,
		};
	}

	optInSuccess(): Action {
		return {
			type: CAMPAIGN_ACTION_TYPE.optInSuccess,
		};
	}

	optInFail(error: AppError): ActionWithPayload {
		return {
			type: CAMPAIGN_ACTION_TYPE.optInFail,
			payload: error,
		};
	}
}
